import { Controller } from '@hotwired/stimulus';

const DEFAULT_ANIMATION_VARIANT = 'glow';

const ANIMATION_VARIANTS = {
  current: 'animate-needs-attention-count-highlight',
  'double-pulse': 'animate-needs-attention-count-highlight-double-pulse',
  scale: 'animate-needs-attention-count-highlight-scale',
  glow: 'animate-needs-attention-count-highlight-glow',
  'glow-orange': 'animate-needs-attention-count-highlight-glow',
  'glow-red': 'animate-needs-attention-count-highlight-glow',
  badge: 'animate-needs-attention-count-highlight-badge',
};

export default class extends Controller {
  static targets = ['count'];
  static values = { storageKey: String };

  connect() {
    const previous = this.#readPrevious();
    const current = {};

    this.countTargets.forEach((el) => {
      const key = el.dataset.needsAttentionKey;
      const value = el.textContent.trim();
      current[key] = value;

      if (previous && previous[key] !== value) {
        this.#flash(el);
      }
    });

    this.#writeCurrent(current);
  }

  #flash(el) {
    const variant = this.#animationVariant();
    const animationClass = ANIMATION_VARIANTS[variant] || ANIMATION_VARIANTS[DEFAULT_ANIMATION_VARIANT];

    this.#doubleFire(el, animationClass, Object.values(ANIMATION_VARIANTS));
  }

  #doubleFire(el, animationClass, resetClasses) {
    this.#playAnimation(el, animationClass, resetClasses);
    el.addEventListener('animationend', () => this.#playAnimation(el, animationClass, resetClasses), { once: true });
  }

  #playAnimation(el, animationClass, resetClasses) {
    el.classList.remove(...resetClasses);
    el.offsetHeight;
    el.classList.add(animationClass);
  }

  #animationVariant() {
    return new URLSearchParams(window.location.search).get('attention_anim') || DEFAULT_ANIMATION_VARIANT;
  }

  #readPrevious() {
    try {
      const raw = sessionStorage.getItem(this.storageKeyValue);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  }

  #writeCurrent(current) {
    try {
      sessionStorage.setItem(this.storageKeyValue, JSON.stringify(current));
    } catch {
      // sessionStorage may be unavailable; the animation simply won't fire, which is safe to ignore.
    }
  }
}
